export const ordinalSuffixOf = (() => {
  const suffices = new Map([
    [1, 'st'],
    [2, 'nd'],
    [3, 'rd'],
  ]);
  return (n: number) => {
    const i = n % 10;
    const suffix = ((((n % 100) / 10) | 0) !== 1 && suffices.get(i)) || 'th';
    return `${n}${suffix}`;
  };
})();
